import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VanshavaliFormComponent from "../components/VanshavaliForm/VanshavaliForm";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function loadRecaptchaScript(siteKey) {
  if (!siteKey) return;
  if (document.querySelector('script[data-recaptcha="1"]')) return;
  const s = document.createElement("script");
  s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
  s.async = true;
  s.defer = true;
  s.dataset.recaptcha = "1";
  document.head.appendChild(s);
}

async function getRecaptchaToken(siteKey) {
  if (!siteKey || !window.grecaptcha) return "";
  await new Promise((resolve) => window.grecaptcha.ready(resolve));
  return window.grecaptcha.execute(siteKey, { action: "submit" });
}

function VanshavaliForm() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    loadRecaptchaScript(RECAPTCHA_SITE_KEY);
  }, []);

  useEffect(() => {
    if (error) window.scrollTo({ top: 0, behavior: "smooth" });
  }, [error]);

  const handleSubmit = async (data) => {
    const submitUrl = process.env.REACT_APP_VANSHAVALI_FORM_URL;
    if (!submitUrl) {
      setError("Form endpoint is not configured. Please contact the administrator.");
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      if (RECAPTCHA_SITE_KEY) {
        data._captcha = await getRecaptchaToken(RECAPTCHA_SITE_KEY);
      }
      const res = await fetch(submitUrl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "text/plain;charset=utf-8" },
      });
      const json = await res.json();
      if (!json.ok) throw new Error(json.error || "Submission failed");
      navigate("/vanshavali/form/thank-you", {
        state: { formNumber: json.formNumber },
        replace: true,
      });
    } catch (err) {
      setError(
        "Sorry, something went wrong while submitting. Please check your internet connection and try again."
      );
      setSubmitting(false);
    }
  };

  return (
    <div className="py-3 py-lg-4">
      <div className="container mb-3">
        <h1 className="h3 mb-2">Vanshavali Changes Form</h1>
        <p className="text-muted mb-3" style={{ fontSize: "0.95rem" }}>
          For the best experience, please fill this form on a tablet or
          computer. You can use a phone too, but a larger screen makes it
          easier to see and fill the family tree.
        </p>
        {error && <div className="alert alert-danger mb-0">{error}</div>}
      </div>
      <VanshavaliFormComponent onSubmit={handleSubmit} submitting={submitting} />
    </div>
  );
}

export default VanshavaliForm;
